import H2 from 'core/components/H2';
import Button from 'core/components/Button';
import Link from 'core/components/Link';
import { Desktop, Mobile } from 'core/components/breakpoint';

import { MaxWidthWrapper } from 'site/components/Wrappers';

import styles from './index.styl';

export default function ResetPasswordSuccess() {
  const title = <H2 is='h1'>Пароль успешно восстановлен!</H2>;

  return (
    <MaxWidthWrapper>
      <Mobile>{title}</Mobile>
      <div className={styles.success}>
        <Desktop>{title}</Desktop>
        <Link to='/login' className={styles.link}>
          <Button>Авторизоваться</Button>
        </Link>
      </div>
    </MaxWidthWrapper>
  );
}
